const IS_DEMO =
  process.env.NODE_ENV === "production" &&
  window.location.hostname === "demo.growfinportal.com";

const IS_DEMO_CUSTOMER = "EaFjy2i10VCwDb";
export { IS_DEMO, IS_DEMO_CUSTOMER };
